import _ from "lodash";

export const kpiBenchmarkByMachineFamily = machineFamily => {
  const default_kpi = "PARTS_HOUR";
  return (
    {
      CDL: default_kpi,
      EBA: "PASSES_MINUTE",
      BOR: default_kpi,
      SEZ: default_kpi,
      PLS: "METERS_HOUR"
    }[machineFamily] || default_kpi
  );
};

export const kpiSingleBenchmarkByMachineFamily = machineFamily => {
  const default_kpi = "PARTS";
  return (
    {
      CDL: default_kpi,
      EBA: "PASSES",
      BOR: default_kpi,
      SEZ: default_kpi,
      PLS: "METERS"
    }[machineFamily] || default_kpi
  );
};

export const setGoalHourOrMinuteByMachineFamily = (machineFamily, value) => {
  const defaul_multiply = 1;
  const multiplay_by =
    {
      CDL: defaul_multiply,
      EBA: 60,
      BOR: defaul_multiply,
      SEZ: defaul_multiply
    }[machineFamily] || defaul_multiply;

  return value * multiplay_by;
};
export const getGoalHourOrMinuteByMachineFamily = (machineFamily, value) => {
  const default_divide = 1;
  const divide_by =
    {
      CDL: default_divide,
      EBA: 60,
      BOR: default_divide,
      SEZ: default_divide
    }[machineFamily] || default_divide;

  return _.round(value / divide_by, 2);
};

export const mapAnalyticsDataByMachineFamily = (machine, data) => {
  const newMapValue =
    {
      EBA: {
        ...data,
        Pieces: {
          ...data.Pieces,
          Velocity: getGoalHourOrMinuteByMachineFamily("EBA", data.Pieces.Velocity),
          Goal: getGoalHourOrMinuteByMachineFamily("EBA", data.Pieces.Goal)
        }
      },
      CDL: data,
      BOR: data,
      SEZ: data
    }[machine.MachineFamily] || data;

  return newMapValue;
};
